import { render, staticRenderFns } from "./InputTaoSir.vue?vue&type=template&id=dab210a6&scoped=true"
import script from "./InputTaoSir.vue?vue&type=script&lang=js"
export * from "./InputTaoSir.vue?vue&type=script&lang=js"
import style0 from "./InputTaoSir.vue?vue&type=style&index=0&id=dab210a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab210a6",
  null
  
)

export default component.exports